import React from "react";
import ProductPageSettingPanelComponent from './productPageSettingPanel.component';

export default function ProductPageSettingPanelContainer() {
  return (
    <ProductPageSettingPanelComponent />
  )
}